<template>
    <el-dialog :title="titleDialog" :visible="showDialog" @close="close" @open="create">
        <template v-if="titleDialog">
            <form autocomplete="off" @submit.prevent="submit" v-if="!has_credit_or_debit">
                <div class="form-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group" :class="{'has-danger': errors[`documents.0.description`]}">
                                <label class="control-label">Descripción del motivo de anulación</label>
                                <el-input v-model="form.documents[0].description" dusk="description"></el-input>

                                <template v-if="errors[`documents.0.description`]">
                                    <small class="form-control-feedback"  v-text="errors[`documents.0.description`][0]"></small>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row form-actions mt-4">
                    <div class="col-md-8">
                        <b class="text-danger" v-if="!config.send_summaries">
                            Recuerda completar la anulación en la sección de Anulaciones
                        </b>
                        <!--
                        <span v-if="hasSaleNote">
                            <label> Tiene asociado la(s) siguiente(s) nota de venta(s): </label>
                            <template v-for="(row,index) in form.sales_note">
                                <label class="d-block" :key="index">{{ row.number_full }} Fecha: {{row.date_of_issue}}</label><br>
                            </template>
                        </span>
                        -->
                    </div>
                    <div class="col-4 text-right">
                        <el-button @click.prevent="close()">Cancelar</el-button>
                        <el-button type="danger" native-type="submit" dusk="annulment-voided" :loading="loading_submit">
                            Anular
                        </el-button>
                    </div>
                </div>
            </form>

            <template v-else>
                <div class="row">
                    <div class="col-12">
                        <label>No se puede anular, porque tiene un comprobante relacionado: 
                            <span>{{ credit_or_debit }}</span>
                            <!-- <span v-for="(item, index) in credit_or_debit" :key="index">{{ item.document }}</span> -->
                        </label>
                    </div>
                </div>
            </template>
        </template>
        
    </el-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex/dist/vuex.mjs"

export default {
    props: ['showDialog', 'recordId'],
    data() {
        return {
            titleDialog: null,
            loading_submit: false,
            resource: null,
            errors: {},
            form: {
                sales_note: [{}],
            },
            group_id: null,
            has_credit_or_debit: false,
            credit_or_debit: null
        }
    },
    computed: {
        hasSaleNote: function () {
            if (
                this.form !== undefined &&
                this.form.sales_note !== undefined &&
                this.form.sales_note.length > 0
            ) {
                return true;
            }

            return false;
        },
        ...mapState([
            'config',
        ]),
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.loading_submit = false,
            this.group_id = null,
            this.errors = {},
            this.form = {
                date_of_reference: null,
                summary_status_type_id: '3',
                sales_note: [{}],
                documents: [
                    {
                        document_id: null,
                        description: null,
                    }
                ]
            }
            this.has_credit_or_debit = false
            this.credit_or_debit = null
            this.titleDialog = null
        },
        create() {
            this.$http.get(`/documents/record/${this.recordId}`)
                .then(response => {
                    let document = response.data.data

                    this.group_id = document.group_id
                    this.form.date_of_reference = document.date_of_issue
                    this.form.documents[0].document_id = document.id
                    this.titleDialog = 'Comprobante: ' + document.number
                    this.form.sales_note = document.sales_note;

                    if (document.credit_or_debit) {
                        this.has_credit_or_debit = true
                        this.credit_or_debit = document.credit_or_debit
                    }

                })
        },
        submit() {
            this.loading_submit = true
            this.resource = (this.group_id === '01') ? 'voided' : 'summaries'
            this.$http.post(`/${this.resource}`, this.form)
                .then(async (response) => {
                    if (response.data.success) {
                        this.$eventHub.$emit('reloadData')
                        this.$message.success(response.data.message)

                        if (this.config.send_summaries) {
                            const { id } = response.data
                            await this.ticketStatus(this.resource, id)
                        }
                        this.close()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .then(() => {
                    this.loading_submit = false
                })
        },
        close() {
            this.$emit('update:showDialog', false)
            this.initForm()
        },

        async ticketStatus(type, id) {
            try {
                this.loading_submit = true
                const response = await this.$http.get(`/${type}/status/${id}`)
                if (response.data.success) {
                    this.$message.success(response.data.message)
                    this.$eventHub.$emit('reloadData')
                } else {
                    this.$message.error(response.data.message)
                }
            } catch (error) {
                this.$message.error(error.response.data.message)
            } finally {
                this.loading_submit = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/documents/partials/voided.vue